import { render, staticRenderFns } from "./HomeHonor.vue?vue&type=template&id=f726e5da&scoped=true&"
import script from "./HomeHonor.vue?vue&type=script&lang=js&"
export * from "./HomeHonor.vue?vue&type=script&lang=js&"
import style0 from "./HomeHonor.vue?vue&type=style&index=0&id=f726e5da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f726e5da",
  null
  
)

export default component.exports